import type { Feedback } from "@/payload-types";
import type { PaginationPayload } from "@/types";

export default async function getFeedbacksPagination(
  page: number,
  limit: number = 8
): Promise<PaginationPayload<Feedback> | undefined> {
  try {
    const response = await fetch(
      `/api/feedbacks?limit=${limit}&sort=-createdAt&page=${page}`
    );
    return await response.json();
  } catch (error) {
    return undefined;
  }
}
